import httpPost from "./httppost";
import httpGet from "./httpget";
const domain = "https://api.pdf365.cn";
// 添加封面页的文件上传服务器
export const docs = (params = {}, config = {}) => {
  return httpPost({
    url: `${domain}/v2/docs?token=2c9f83c56dd7a056016df6361d4e0001`,
    params,
    config
  });
};
// 创建封面页任务
export const jobs = (params = {}, config = {}) => {
  return httpPost({
    url: `${domain}/api/v2/jobs?token=2c9f83c56dd7a056016df6361d4e0001&type=102`,
    params,
    config
  });
};
// 查询封面页任务
export const jobsStatus = (config = {}) =>
  httpGet({
    url: `${domain}/api/v2/jobs/${config.params.id}/status?token=2c9f83c56dd7a056016df6361d4e0001`,
    config
  });
